import React, { useRef, memo } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import ToolTip from '../../ToolTipIcon/ToolTip';
import EddJointActions from '../EddJointActions/EddJointActions';
import Spinner from '../../Spinner/Spinner';

const Edder = memo(props => {
  const {
    filesSelecting,
    setFilesSelecting,
    filesSelected,
    deleteClicked,
    importClicked,
    validateClicked,
    downloadClicked,
    scheduleClicked,
    showJointActions,
    constants,
  } = props;
  const inputRef = useRef(null);

  return (
    <div data-test="edd-actions" className="mt-8">
      <div className="flex  md:space-x-4 md:ml-0 justify-between md:justify-start">
        <ToolTip toolText="Toggle Filter" placement="bottom">
          <button
            type="button"
            data-test="edd-filter-toggle"
            className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
            onClick={props.handleFilterToggle}
          >
            <img
              className="w-[30px] h-[30px] max-w-[30px] max-h-[30px]"
              src="/assets/images/icons/filter.svg"
              alt="Filter"
              draggable={false}
            />
          </button>
        </ToolTip>

        <ToolTip toolText="Upload File (xls or csv)" placement="bottom">
          <button
            type="button"
            className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
            data-test="select-edd-file"
            onClick={() => {
              setFilesSelecting(true);
              inputRef.current.click();
              setTimeout(() => setFilesSelecting(false), 2000);
            }}
          >
            <img
              src="/assets/images/icons/file_upload.svg"
              alt="Upload file"
              className="w-[30px] h-[30px] max-w-[30px] max-h-[30px]"
            />
          </button>
        </ToolTip>
        {filesSelecting && <Spinner className="small-spinner" loading />}
        {constants.edd_docs_link && (
          <ToolTip toolText="Read the docs" placement="bottom">
            <button
              aria-label="read-the-docs"
              type="button"
              className="duration-500 hover:scale-105 w-[50px] text-[#0A364B] cursor-pointer h-[50px] flex justify-center items-center bg-white rounded-lg"
              onClick={() => {
                window.open(constants.edd_docs_link, '_blank');
              }}
            >
              <img
                src="/assets/images/icons/book.svg"
                alt="Read the docs"
                className="w-[30px] h-[30px] max-w-[30px] max-h-[30px]"
              />
            </button>
          </ToolTip>
        )}
        {showJointActions && (
          <EddJointActions
            filesSelected={filesSelected}
            deleteClicked={deleteClicked}
            importClicked={importClicked}
            validateClicked={validateClicked}
            downloadClicked={downloadClicked}
            scheduleClicked={scheduleClicked}
          />
        )}
        <input
          className="absolute overflow-hidden w-px h-px pointer-events-none"
          type="file"
          data-test="edd-file-input"
          ref={inputRef}
          multiple
          accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          onInput={e => {
            props.handleInputChange(e);
            inputRef.current.value = '';
          }}
        />
      </div>
    </div>
  );
});

Edder.propTypes = {
  filesSelecting: PropTypes.bool,
  showJointActions: PropTypes.bool,
  setFilesSelecting: PropTypes.func,
  handleInputChange: PropTypes.func,
  handleFilterToggle: PropTypes.func,
  filesSelected: PropTypes.array,
  deleteClicked: PropTypes.func,
  importClicked: PropTypes.func,
  validateClicked: PropTypes.func,
  downloadClicked: PropTypes.func,
  scheduleClicked: PropTypes.func,
  constants: PropTypes.shape({
    edd_docs_link: PropTypes.string,
  }),
};

const mapStateToProps = state => ({
  constants: state.constants?.data || {},
});

export default withRouter(connect(mapStateToProps)(Edder));
